import I18n from "i18n-js";
import React from "react";
import Switch from "../Switch/Switch";

class MenuBuilder extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return <div className="MenuBuilder">{this.renderMenuItems()}</div>;
  }

  renderMenuItems() {
    return this.props.menu_items.map((menu_item) => {
      const translated_name = I18n.lookup(menu_item.name);
      return (
        <div key={menu_item.id} className="menu-item">
          <div className="parent-menu-item">
            <input
              type="text"
              name={menu_item.id}
              value={translated_name || menu_item.name}
              onChange={this.props.onChangeMenuItemName}
              className="form-control"
            />
            <Switch
              onChange={this.props.onChangeMenuItemStatus}
              switchId={menu_item.id}
              name={menu_item.id}
              value={menu_item.status === "enabled"}
              onText="enabled"
              offText="disabled"
            />
          </div>
          {menu_item.child_menu_items && menu_item.child_menu_items.length ? (
            <div className="child-menu-items">
              {menu_item.child_menu_items
                .filter((child_menu_item) => {
                  return !child_menu_item.divider;
                })
                .map((child_menu_item) => {
                  const translated_child_menu_item_name = I18n.lookup(
                    child_menu_item.name
                  );
                  return (
                    <div key={child_menu_item.id} className="child-menu-item">
                      <input
                        type="text"
                        name={child_menu_item.id}
                        value={
                          translated_child_menu_item_name ||
                          child_menu_item.name
                        }
                        onChange={this.props.onChangeMenuItemName}
                        className="form-control"
                      />
                      <Switch
                        onChange={this.props.onChangeMenuItemStatus}
                        switchId={child_menu_item.id}
                        name={child_menu_item.id}
                        value={child_menu_item.status === "enabled"}
                        onText="enabled"
                        offText="disabled"
                      />
                    </div>
                  );
                })}
            </div>
          ) : null}
        </div>
      );
    });
  }
}

export default MenuBuilder;
